import React, { useState } from "react";
import "./FundishHigher.css";

const FundishHigher = ({ data }) => {
  const [FundsHigh] = useState(data);
  return (
    <div className="boxtableFundishAlert-lealtad">
      <table className="tableFundishAlerts-lealtad">
        <thead>
          <tr>
            <th className="tableFundishHeader-lealtad">Usuario</th>
            <th className="tableFundishHeader-lealtad">Dni / Cuil</th>
            <th className="tableFundishHeader-lealtad">Relacion con la Mutual</th>
            <th className="tableFundishHeader-lealtad">Mes</th>
            <th className="tableFundishHeader-lealtad">Excedente</th>
          </tr>
        </thead>
        <tbody>
          {FundsHigh.map((item, index) => {
            return (
              <tr key={index}>
                <td className="tableFundishData-lealtad">{item.userName}</td>
                <td className="tableFundishData-lealtad">{item.identify}</td>
                <td className="tableFundishData-lealtad">{item.relation}</td>
                <td className="tableFundishData-lealtad">{item.month}</td>
                <td className="tableFundishData-lealtad">{item.exceededAmount}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FundishHigher;
